import React, { useEffect } from 'react';
import * as THREE from 'three';
import {
	COLOR_SPACE_MAP,
	OUTPUT_ENCODING_MAP,
	TONE_MAPPING_TYPES,
} from '../utils/constants';

export default function Renderer({
	sceneId,
	renderer_config = {},
	rendererRef,
	canvasRef,
	type = 'containerInstance',
	children,
	...rest
}) {
	const { tone_mapping = 'no', tone_mapping_exposure = 1 } = renderer_config;

	console.log('=== RENDERER ==', {
		sceneId,
		renderer_config,
		rendererRef,
		canvasRef,
		children,
	});

	/***  Mounting only ***/
	useEffect(() => {
		// rendererRef.current = getRenderer(type);

		const canvasEl = canvasRef.current;
		rendererRef.current.setSize(
			canvasEl.offsetWidth,
			canvasEl.offsetHeight,
		);
		rendererRef.current.setPixelRatio(window.devicePixelRatio);
		// rendererRef.current.setClearColor(rest.clearColor); TODO: change this to transparent dynamically or can it be left transparent
		canvasRef.current.appendChild(rendererRef.current.domElement);
		rendererRef.current.info.autoReset = true; // MUST BE TRUE or default/unset!!!  to support animated models

		const windowResizeHandler = () => {
			rendererRef.current.setSize(
				canvasRef.current.offsetWidth,
				canvasRef.current.offsetHeight,
			);
		};

		window.addEventListener('resize', windowResizeHandler);

		return () => {
			window.removeEventListener('resize', windowResizeHandler);
			rendererRef.current.dispose();
			rendererRef.current.domElement.remove();
			delete window[`${type}_renderer`];
		};
	}, []); //empty, NO dep here allowed!!!

	/***  New Scene ***/
	useEffect(() => {
		rendererRef.current.toneMapping =
			TONE_MAPPING_TYPES[tone_mapping] || THREE.NoToneMapping;
		rendererRef.current.toneMappingExposure = tone_mapping_exposure;

		if (
			'output_color_space' in renderer_config &&
			renderer_config.output_color_space in COLOR_SPACE_MAP
		) {
			rendererRef.current.outputColorSpace =
				COLOR_SPACE_MAP[renderer_config.output_color_space];
		} else if (
			'output_encoding' in renderer_config &&
			renderer_config.output_encoding in OUTPUT_ENCODING_MAP
		) {
			rendererRef.current.outputColorSpace =
				OUTPUT_ENCODING_MAP[renderer_config.output_encoding];
		} else {
			rendererRef.current.outputColorSpace = THREE.SRGBColorSpace;
		}

		rendererRef.current.needsUpdate = true;

		return () => {
			rendererRef.current.toneMapping = THREE.NoToneMapping;
			rendererRef.current.toneMappingExposure = 1;
			rendererRef.current.outputColorSpace = THREE.SRGBColorSpace;
		};
	}, [sceneId]);

	return <>{children}</>;
}
